/* eslint-disable import/prefer-default-export */
import * as lc from '../../../../../utils/lodashCustom';
import * as dateFormatter from '../../../../../utils/formatter';

export function restructureUserNoticeModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    message: lc.get(data, 'message'),
    noticeAppStatus: lc.get(data, 'notice_app_status'),
    createdAt: lc.get(data, 'created_at'),
    createdAtFormatted: dateFormatter.dateFormat1(lc.get(data, 'created_at')),
    typeTitle: lc.get(data, 'type.title'),
    typeCategoryTitle: lc.get(data, 'type_category.title'),
    eventTypeId: lc.get(data, 'event.event_type_id'),
    descTemplate: lc.get(data, 'type.desc_template'),
    eventArgs: lc.get(data, 'event.event_args')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/events/services/EventsUserNoticeService/restructuring/index.js